<template>
    <div v-show="linkedCustomers.length > 1">
        <jet-dropdown align="left" width="48">
            <template #trigger>
                <span class="block border rounded-md hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition">
                    <button type="button" class="w-full flex justify-between items-center p-2 border border-transparent text-xs leading-4 font-medium rounded-md text-gray-500 bg-white hover:text-gray-700 focus:outline-none transition">
                        {{ activeCustomer ? activeCustomer.name : '' }}

                        <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                        </svg>
                    </button>
                </span>
            </template>

            <template #content>
                <!-- Change active customer -->
                <form>
                    <span class="block px-4 py-2 leading-5 text-gray-700 cursor-pointer text-xs"
                        v-for="customer in customerOptions" :key="customer.id" @click="changeActiveCustomer(customer.id)">
                        {{ customer.name }}
                    </span>
                </form>
            </template>
        </jet-dropdown>
    </div>
</template>

<script>
import JetDropdown from '@/Jetstream/Dropdown';
import { usePage } from '@inertiajs/inertia-vue3';
import { useForm } from '@inertiajs/inertia-vue3';
import UseUserAuth from '@/Composables/UseUserAuth';

export default {
    components: {
        JetDropdown,
    },

    setup () {
        const { isAdmin, isCustomer } = UseUserAuth(usePage().props.value.user);

        const customerForm = useForm({
            id: usePage().props.value.activeCustomer ? usePage().props.value.activeCustomer.id : null,
        })

        return {
            isAdmin,
            isCustomer,
            customerForm,
        }
    },

    data() {
        return {
            linkedCustomers: [],
        }
    },

    methods: {
        changeActiveCustomer(id) {

            if(this.activeCustomer.id !== id)
            {
               this.customerForm.id = id;

                if(!this.customerForm.processing) {
                    this.customerForm.submit('post', route('activecustomer.set.active'));
                }
            }

        },


        fetchLinkedCustomers() {

            axios.get(route('activecustomer.get.linked'))
            .then(response => {
                if(response.data.length) {
                    this.linkedCustomers = response.data;
                }

            })
            .catch(error => {
                console.log(error);
            });

        }
    },

    computed: {

        customerOptions() {
            if(this.linkedCustomers.length)
            {
                return this.linkedCustomers.map(i => {
                    return {
                        name: i.name,
                        id: i.id
                    }
                });
            }
        },

        activeCustomer() {
            return this.$page.props.activeCustomer;
        }

    },

    mounted () {
        this.fetchLinkedCustomers();
    }
}



</script>